exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n/* main */\n.search[data-v-9bc859e6] {\n    position: relative;\n}\n\n\n/* input */\n.search .input[data-v-9bc859e6] {\n    height: 34px;\n}\n.search .input svg.close[data-v-9bc859e6] {\n    cursor: pointer;\n}\n\n\n", ""]);
